module.exports = __webpack_public_path__ + "5f4a3ae71c5474a7ea656eb23b89e771.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/user/notes/add/add-note.html
// module id = 2502
// module chunks = 0